import { z } from 'zod';
import { es } from 'zod/v4/locales';

z.config(es());

export { z };
